var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('div',{staticClass:"pie",attrs:{"id":"pie1"}}),_c('div',{staticClass:"pie",attrs:{"id":"pie2"}}),_c('div',{staticClass:"pie",attrs:{"id":"pie3"}}),_c('div',{staticClass:"pie",attrs:{"id":"pie4"}}),_c('div',{staticClass:"pie",attrs:{"id":"pie5"}}),_c('div',{staticClass:"pie",attrs:{"id":"pie6"}})])
}]

export { render, staticRenderFns }